// "Don't forget this" cart suggestion (snippets/nds-cart-extras.liquid), 21 October 2026.
// Shows one random candidate per block and keeps that pick until it is added or gone.
// In the slide-out cart, the nds-header fetch hook refreshes the drawer after /cart/add.
// On the cart page, a cart:update event makes main-cart re-render; the drawer stays closed.
// Added lines carry the hidden property _source: cart-extra so use can be counted in orders.
let pickedId = null;

const pick = () => {
  document.querySelectorAll('[data-nds-extras]').forEach((block) => {
    const items = [...block.querySelectorAll('[data-nds-extra-item]')];
    if (!items.length || items.some((item) => item.hasAttribute('data-picked') && item.dataset.ndsExtraItem === pickedId)) return;

    let choice = items.find((item) => item.dataset.ndsExtraItem === pickedId);
    if (!choice) {
      choice = items[Math.floor(Math.random() * items.length)];
      pickedId = choice.dataset.ndsExtraItem;
    }
    items.forEach((item) => item.toggleAttribute('data-picked', item === choice));
  });
};

let pickQueued = false;
const queuePick = () => {
  if (pickQueued) return;
  pickQueued = true;
  requestAnimationFrame(() => {
    pickQueued = false;
    pick();
  });
};

// Both carts re-render from the server (innerHTML swap or morph), which drops the pick.
new MutationObserver(queuePick).observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['data-picked'],
});
pick();

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-nds-extra-add]');
  if (!button || button.getAttribute('aria-busy') === 'true') return;
  event.preventDefault();

  const onCartPage = !button.closest('[data-cart-drawer]');
  button.setAttribute('aria-busy', 'true');

  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{ id: Number(button.dataset.ndsExtraAdd), quantity: 1, properties: { _source: 'cart-extra' } }],
      }),
      ndsStayOnPage: onCartPage,
    });
    if (!response.ok) throw new Error(response.status === 422 ? 'Sold out' : 'Try again');
    button.textContent = 'Added';

    if (onCartPage) {
      const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { credentials: 'same-origin' }).then((r) => r.json());
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'nds-cart-extras', data: { source: 'nds-cart-extras', itemCount: cart.item_count } },
        })
      );
    }
  } catch (error) {
    button.textContent = error.message === 'Sold out' ? 'Sold out' : 'Try again';
  } finally {
    button.removeAttribute('aria-busy');
  }
});
